/**
 * @module Experience/Plan-Details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// INTERFACES
import { PlanOption } from '@support/api/proxies/responses/api-2123.interface';
import { PlansDetails } from '@experience/shop/plan-details/interfaces/family-details.interface';
import { SHARED_BROWSE_CONSTANTS } from '@experience/shop/shared-browse/constants/shared-browse.constants';

export class PlanOptionsModel {
  /**
   * To store plan options
   */
  private planOption: PlansDetails[];

  constructor(planOptions: PlanOption[]) {
    this.planOption = this.setPlanOptions(planOptions);
  }

  /**
   * To get Plan Options
   * @returns PlansDetails[]
   */
  public getPlanOptions(): PlansDetails[] {
    return this.planOption;
  }

  /**
   * To set Plan Options
   * @param planOptions of type PlanOption[]
   * @returns PlansDetails[]
   */
  private setPlanOptions(planOptions: PlanOption[]): PlansDetails[] {
    const plansArray = planOptions.map((plan: PlanOption) => {
      return {
        planName: plan.label ? plan.label : '',
        displayPrice: this.getDisplayPrice(plan),
        offerCode: plan.attribute,
        shortDescription: plan.shortDescription ? plan.shortDescription : '',
        planId: plan.planOptionSelectorId,
        planDescription: plan.description,
        planLongDescription: plan.longDescription,
        planLegalText: plan.alternateDescriptions[0].text,
        planAlternateDesription: plan.alternateDescriptions[0].text,
        isGrandFathered: plan.isGrandFathered,
        periodLength: plan.periodLength ? plan.periodLength : SHARED_BROWSE_CONSTANTS.UNDEFINED,
        periodLengthMeasurementUnit: plan.periodLengthMeasurementUnit
          ? plan.periodLengthMeasurementUnit
          : SHARED_BROWSE_CONSTANTS.UNDEFINED,
        autopayDiscDetails: plan?.autopayDiscDetails
      };
    });
    if (plansArray) {
      return plansArray;
    } else {
      return null;
    }
  }

  /**
   * To get Display Price
   * @param plan of type PlanOption
   * @return string
   */
  private getDisplayPrice(plan: PlanOption): string {
    if (plan.monthlyPrice && plan.monthlyPrice.displayValue) {
      return plan.monthlyPrice.displayValue;
    } else {
      return '';
    }
  }
}
